/* ==========================================================================
   HODL Final Seal – Schlusskapitel und Fuss der Seite (Custom Element <hodl-final-seal>)
   Ablauf wie im freigegebenen Claude-Design-Prototyp «HODL Final Seal Footer v2» (Marco, 04.11.2026):
   A Lichtspuren laufen beim Annähern zum Kern, B der Kern taucht auf, C die Ringe drehen sich ein und die Riegel
   rasten, D Bestätigungspuls, E Schlusssatz, F Lichtspur zur Vertrauenszeile und zum Fuss, G Ruhe.
   Nur CSS, SVG, ein kleines 2D-Canvas für den Goldstaub und Web Animations; kein Three.js.
   Arbeitet nur, wenn das Finale in der Nähe ist; pausiert ausserhalb und in Hintergrund-Tabs.
   Reduzierte Bewegung, Einstellung «Ruhig» und Theme-Editor: sofort das Endbild.
   Die Linkgruppen am Handy und das Newsletter-Formular funktionieren unabhängig von der Animation.
   ========================================================================== */
(() => {
  if (customElements.get('hodl-final-seal')) return;

  const cl = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const eo = (x) => 1 - Math.pow(1 - x, 3);
  const eio = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
  const P = (a, r) => {
    const t = ((a - 90) * Math.PI) / 180;
    return [(500 + r * Math.cos(t)).toFixed(1), (500 + r * Math.sin(t)).toFixed(1)];
  };
  const ticks = (n, r1, r2, every, r2b) => {
    let d = '';
    for (let i = 0; i < n; i++) {
      const a = (i * 360) / n;
      const R = every && i % every === 0 ? r2b : r2;
      const [x1, y1] = P(a, r1);
      const [x2, y2] = P(a, R);
      d += `M${x1} ${y1}L${x2} ${y2}`;
    }
    return d;
  };
  const arc = (r, a0, a1) => {
    const [x0, y0] = P(a0, r);
    const [x1, y1] = P(a1, r);
    return `M${x0} ${y0}A${r} ${r} 0 0 1 ${x1} ${y1}`;
  };
  const SVG = (inner, extra) => `<svg viewBox="0 0 1000 1000" fill="none" ${extra || ''}>${inner}</svg>`;
  const SCHRIFT = 'font-family:var(--font-heading-family, sans-serif)';
  const MONO = "font-family:ui-monospace,'SFMono-Regular','Cascadia Mono',Menlo,Consolas,monospace";

  // Aussenring: Skala, gravierte Ringschrift mit wanderndem Goldverlauf, vier LED-Bögen, Indexmarke
  function outerSvg(u, goldAn) {
    const txt = ['JUST HODL IT', 'DON’T TRUST, VERIFY', 'SELF CUSTODY', 'OFFLINE KEYS'].join('  ◆  ') + '  ◆  ';
    const leds = [45, 135, 225, 315].map((a) => arc(474, a - 3.5, a + 3.5)).join('');
    const tp = (fill, extra) =>
      `<text font-size="21" font-weight="700" letter-spacing="0" style="${SCHRIFT}" fill="${fill}" ${extra || ''}><textPath href="#hfsRing-${u}" textLength="2686" lengthAdjust="spacing">${txt + txt}</textPath></text>`;
    const base = SVG(`<defs>
      <path id="hfsRing-${u}" d="M500 69A431 431 0 1 1 500 931A431 431 0 1 1 500 69"/>
      <linearGradient id="hfsGT-${u}" gradientUnits="userSpaceOnUse" x1="70" y1="500" x2="930" y2="500">
        <stop offset="0" stop-color="#7a5520"/><stop offset=".28" stop-color="#c9973f"/><stop offset=".45" stop-color="#fff4d2"/><stop offset=".53" stop-color="#f3d488"/><stop offset=".72" stop-color="#b38433"/><stop offset="1" stop-color="#6e4c18"/>
        <animateTransform attributeName="gradientTransform" type="rotate" from="0 500 500" to="360 500 500" dur="14s" repeatCount="indefinite"/>
      </linearGradient>
      <linearGradient id="hfsGS-${u}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f6dc94"/><stop offset=".5" stop-color="#7a5520"/><stop offset="1" stop-color="#e9c46a"/></linearGradient>
    </defs>
      <path d="${ticks(240, 492.5, 499.2)}" stroke="rgba(255,255,255,0.17)" stroke-width="1.1"/>
      <circle cx="500" cy="500" r="485" stroke="rgba(0,0,0,0.7)" stroke-width="1.6"/>
      <circle cx="500" cy="500" r="466" stroke="rgba(0,0,0,0.5)" stroke-width="3"/>
      <circle cx="500" cy="500" r="463" stroke="${goldAn ? `url(#hfsGS-${u})` : 'rgba(255,255,255,0.14)'}" stroke-width="1.3" opacity="0.85"/>
      <circle cx="500" cy="500" r="417" stroke="${goldAn ? `url(#hfsGS-${u})` : 'rgba(255,255,255,0.14)'}" stroke-width="1.3" opacity="0.85"/>
      <circle cx="500" cy="500" r="414" stroke="rgba(0,0,0,0.5)" stroke-width="3"/>
      ${tp('rgba(0,0,0,0.75)', 'transform="translate(0 1.6)"')}
      ${tp(goldAn ? `url(#hfsGT-${u})` : 'rgba(226,226,236,0.42)')}
      <path d="${ticks(120, 400, 407, 10, 412)}" stroke="rgba(255,255,255,0.2)" stroke-width="1.2"/>
      <path d="${leds}" stroke="rgba(214,58,208,0.22)" stroke-width="4.5" stroke-linecap="round"/>
      <path d="${leds}" stroke="rgba(0,0,0,0.6)" stroke-width="1" stroke-linecap="round" transform="translate(0 -1.5)"/>
      <path d="M489 393L511 393L500 410Z" fill="#dcdce4"/>`);
    const lit = SVG(`<path d="${leds}" stroke="rgba(230,80,225,0.3)" stroke-width="14" stroke-linecap="round"/>
      <path d="${leds}" stroke="#f27cec" stroke-width="4.5" stroke-linecap="round"/>
      <circle cx="500" cy="401" r="11" fill="rgba(230,80,225,0.3)"/><circle cx="500" cy="400" r="3" fill="#ffb0f8"/>`, 'data-lit="1"');
    return base + lit;
  }

  // Innenring: Minutenskala, Zahlen, Kerben, drei Schrauben, Indexmarke
  function innerSvg() {
    let notches = '';
    let nums = '';
    for (let i = 0; i < 12; i++) {
      notches += `<rect x="495" y="194" width="10" height="20" rx="2.5" fill="#060608" stroke="rgba(255,255,255,0.09)" transform="rotate(${i * 30 + 15} 500 500)"/>`;
      if (i) nums += `<text x="500" y="184" text-anchor="middle" font-size="16" font-weight="500" style="${MONO}" fill="rgba(226,226,236,0.55)" transform="rotate(${i * 30} 500 500)">${String(i * 5).padStart(2, '0')}</text>`;
    }
    let screws = '';
    [60, 180, 300].forEach((a, i) => {
      const [x, y] = P(a, 276);
      screws += `<g transform="translate(${x} ${y}) rotate(${25 + i * 50})"><circle r="7.5" fill="#1d1d23" stroke="rgba(255,255,255,0.22)" stroke-width="1.1"/><path d="M-5 0L5 0" stroke="rgba(0,0,0,0.85)" stroke-width="2.2"/></g>`;
    });
    const base = SVG(`<circle cx="500" cy="500" r="371" stroke="rgba(0,0,0,0.55)" stroke-width="1.5"/>
      <path d="${ticks(120, 359, 366, 0)}" stroke="rgba(230,230,240,0.36)" stroke-width="1"/>
      <path d="${ticks(12, 345, 366, 0)}" stroke="rgba(238,238,246,0.75)" stroke-width="2.2"/>
      ${nums}
      <circle cx="500" cy="500" r="312" stroke="rgba(0,0,0,0.6)" stroke-width="2"/>
      <circle cx="500" cy="500" r="310.5" stroke="rgba(255,255,255,0.06)" stroke-width="1"/>
      ${notches}${screws}
      <path d="M500 128L500 160" stroke="#eeeef4" stroke-width="3.4" stroke-linecap="round"/>`);
    const lit = SVG(`<circle cx="500" cy="500" r="312" stroke="rgba(230,80,225,0.32)" stroke-width="1"/>
      <path d="M500 128L500 160" stroke="rgba(230,80,225,0.35)" stroke-width="12" stroke-linecap="round"/>
      <path d="M500 128L500 160" stroke="#ff9af6" stroke-width="3.2" stroke-linecap="round"/>`, 'data-lit="1"');
    return base + lit;
  }

  // Lichtkanten auf den Ringen
  function lightSvg(u) {
    const c = (r, g, w) => `<circle cx="500" cy="500" r="${r}" stroke="url(#${g}-${u})" stroke-width="${w}"/>`;
    return SVG(`<defs>
      <linearGradient id="hfsHT-${u}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".45"/><stop offset=".5" stop-color="#fff" stop-opacity=".04"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>
      <linearGradient id="hfsHB-${u}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#000" stop-opacity=".65"/><stop offset=".55" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#fff" stop-opacity=".24"/></linearGradient>
    </defs>${c(499.2, 'hfsHT', 1.6)}${c(395.6, 'hfsHB', 1.4)}${c(391.6, 'hfsHT', 0.8)}${c(380.6, 'hfsHB', 0.8)}${c(375.4, 'hfsHT', 1.4)}${c(262.6, 'hfsHB', 1.2)}${c(231.6, 'hfsHT', 1.8)}`);
  }

  function boltsHtml() {
    let h = '';
    for (let i = 0; i < 8; i++) h += `<div class="hfs__bolt" style="transform:rotate(${22.5 + i * 45}deg)"><i></i></div>`;
    return h;
  }

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class HodlFinalSeal extends HTMLElement {
    connectedCallback() {
      if (this.alive) return;
      this.alive = true;
      this.ab = [];
      this.anims = [];
      this.timers = [];
      this.played = {};
      this.vis = {};
      this.E = {};
      this.querySelectorAll('[data-k]').forEach((n) => {
        if (!this.E[n.dataset.k]) this.E[n.dataset.k] = n;
      });
      this.uid = (this.id || 'hfs').replace(/[^a-zA-Z0-9_-]/g, '');
      this.gold = this.dataset.gold || 'dezent';
      this.partikel = this.dataset.partikel !== 'false';
      this.design = !!(window.Shopify && window.Shopify.designMode);
      this.mqRuhig = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion = this.dataset.finale === 'animiert' && !this.mqRuhig.matches && !this.design;
      this.classList.add('is-live');
      if (!this.motion) this.classList.remove('is-armed');

      this.akkordeon();
      this.newsletter();
      this.reveal();
      this.siegel();
      this.on(this.mqRuhig, 'change', () => {
        if (this.mqRuhig.matches && this.motion) {
          this.motion = false;
          this.endbild();
        }
      });
      this.on(document, 'visibilitychange', () => this.pauseGold());
      this.on(document, 'shopify:section:select', (e) => {
        if (e.target && e.target.contains && e.target.contains(this)) this.endbild();
      });

      if (!this.E.finale) return;
      // Der Kern wird erst gebaut, wenn das Finale näher als rund eine Bildschirmhöhe ist
      const nah = new IntersectionObserver(
        (es) => {
          if (!es.some((e) => e.isIntersecting)) return;
          nah.disconnect();
          if (this.alive) this.bauen();
        },
        { rootMargin: '900px 0px' }
      );
      nah.observe(this.E.finale);
      this.ab.push(() => nah.disconnect());
    }

    disconnectedCallback() {
      this.alive = false;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      clearTimeout(this.gT);
      clearTimeout(this.shimT);
      this.ab.forEach((f) => f());
      this.ab = [];
      this.clearSeq();
      [this.goldSpin, this.swissShim, this.cShimA].forEach((a) => a && a.cancel());
      this.goldSpin = this.swissShim = this.cShimA = null;
      this.gebaut = false;
      this.fertig = false;
    }

    on(ziel, typ, f, opt) {
      if (!ziel) return;
      ziel.addEventListener(typ, f, opt);
      this.ab.push(() => ziel.removeEventListener(typ, f, opt));
    }

    // ---------- Linkgruppen (Handy: unter 768 px aufklappbar, unabhängig voneinander) ----------
    akkordeon() {
      this.querySelectorAll('[data-hfs-acc]').forEach((btn) => {
        const gruppe = btn.closest('.hfs__group');
        this.on(btn, 'click', () => {
          const offen = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', String(offen));
          if (gruppe) gruppe.classList.toggle('is-open', offen);
        });
      });
    }

    // ---------- Newsletter: Prüfung im Browser, Senden an Shopify (Kundenformular) ----------
    newsletter() {
      const form = this.querySelector('[data-hfs-nl]');
      if (!form) return;
      const input = form.querySelector('input[type="email"]');
      const err = form.querySelector('[data-hfs-nl-err]');
      const live = this.querySelector('[data-hfs-live]');
      if (!input || !err) return;
      form.setAttribute('novalidate', '');
      const pruefe = (v) => {
        const s = (v || '').trim();
        if (!s) return 'Bitte gib deine E-Mail-Adresse ein.';
        if (!EMAIL.test(s)) return 'Bitte prüfe das Format, z. B. name@beispiel.ch.';
        return '';
      };
      const zeige = (m) => {
        err.textContent = m;
        err.hidden = !m;
        if (m) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
        if (live && m) live.textContent = m;
      };
      this.on(form, 'submit', (e) => {
        const m = pruefe(input.value);
        if (m) {
          e.preventDefault();
          zeige(m);
          input.focus();
        } else {
          input.value = input.value.trim();
        }
      });
      this.on(input, 'input', () => {
        if (input.getAttribute('aria-invalid') === 'true') zeige(pruefe(input.value));
      });
      // Feine Lichtspur um das Feld beim Fokussieren
      this.on(input, 'focus', () => {
        const host = form.querySelector('[data-hfs-trace]');
        if (!host || !this.motionErlaubt()) return;
        host.innerHTML = '<svg><rect x="0.5" y="0.5" width="calc(100% - 1px)" height="calc(100% - 1px)" rx="4" pathLength="100" fill="none" stroke="#f07ced" stroke-width="1" stroke-dasharray="16 84"/></svg>';
        const r = host.querySelector('rect');
        if (r && r.animate) r.animate([{ strokeDashoffset: 0, opacity: 0 }, { opacity: 1, offset: 0.1 }, { opacity: 1, offset: 0.8 }, { strokeDashoffset: -100, opacity: 0 }], { duration: 1500, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' });
      });
    }

    motionErlaubt() {
      return !this.mqRuhig.matches && !this.design;
    }

    // Zertifikat: Solange das Siegel im Fuss sichtbar ist, verschwindet das schwebende Siegel (kein doppeltes Siegel)
    siegel() {
      const cert = this.querySelector('.hfs__cert');
      const html = document.documentElement;
      if (!cert || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((es) => {
        es.forEach((en) => html.classList.toggle('hfs-zert-da', en.isIntersecting));
      }, { rootMargin: '0px 0px 120px 0px' });
      io.observe(cert);
      this.ab.push(() => {
        io.disconnect();
        html.classList.remove('hfs-zert-da');
      });
    }

    // ---------- Einblenden der Fussteile ----------
    reveal() {
      const els = Array.from(this.querySelectorAll('[data-hfs-reveal]'));
      if (!this.motion) {
        els.forEach((el) => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver(
        (es) => {
          let i = 0;
          es.forEach((en) => {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            en.target.style.setProperty('--d', `${60 + i++ * 90}ms`);
            en.target.classList.add('is-in');
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
      );
      els.forEach((el) => io.observe(el));
      this.ab.push(() => io.disconnect());
      this.revIO = io;
    }

    // ---------- Kern aufbauen ----------
    // In vier kleinen Schritten mit Pausen dazwischen: Am gedrosselten Handy war der Aufbau am Stück eine Aufgabe
    // von 73 ms plus Darstellung bis 159 ms, mitten im Scrollen.
    bauen() {
      if (this.gebaut) return;
      this.gebaut = true;
      const E = this.E;
      const goldAn = this.gold !== 'aus';
      // Touch-Geräte und schmale Fenster: Ringschrift mit ruhendem Goldverlauf, Goldstaub 20-mal pro Sekunde.
      // Der wandernde Verlauf (SMIL) zeichnet die ganze Ringgrafik in jedem Bild neu (gedrosselt rund 14 ms pro Bild).
      this.leicht = !window.matchMedia('(hover: hover) and (pointer: fine)').matches || window.innerWidth < 900;
      this.sT = 0;
      this.tilt = { x: 0, y: 0, tx: 0, ty: 0 };
      this.locked = false;
      const schritte = [
        () => {
          if (E.outerDet) E.outerDet.innerHTML = outerSvg(this.uid, goldAn);
          E.outerLit = E.outerDet && E.outerDet.querySelector('[data-lit]');
          if (E.outerLit) E.outerLit.style.opacity = this.motion ? '0' : '1';
          const svg = E.outerDet && E.outerDet.querySelector('svg');
          if (svg && svg.pauseAnimations) svg.pauseAnimations();
        },
        () => {
          if (E.innerDet) E.innerDet.innerHTML = innerSvg();
          if (E.light) E.light.innerHTML = lightSvg(this.uid);
          if (E.bolts) E.bolts.innerHTML = boltsHtml();
          E.innerLit = E.innerDet && E.innerDet.querySelector('[data-lit]');
          if (E.innerLit) E.innerLit.style.opacity = this.motion ? '0' : '1';
        },
        () => {
          this.buildLines();
          this.initGlitter();
        },
        () => this.verbinden(),
      ];
      let i = 0;
      const weiter = () => {
        this.bauT = 0;
        if (!this.alive) return;
        schritte[i++]();
        if (i < schritte.length) this.bauT = setTimeout(weiter, 16);
      };
      this.ab.push(() => clearTimeout(this.bauT));
      weiter();
    }

    verbinden() {
      const E = this.E;
      this.fertig = true;
      this.onScroll = () => {
        if (this.nahe) this.kick();
      };
      this.on(window, 'scroll', this.onScroll, { passive: true });
      this.on(window, 'resize', () => {
        clearTimeout(this.rzT);
        this.rzT = setTimeout(() => this.layoutFx(), 120);
      }, { passive: true });
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
          clearTimeout(this.roT);
          this.roT = setTimeout(() => this.layoutFx(), 80);
        });
        if (E.lines) ro.observe(E.lines);
        if (E.coreWrap) ro.observe(E.coreWrap);
        this.ab.push(() => {
          ro.disconnect();
          clearTimeout(this.roT);
          clearTimeout(this.rzT);
        });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.alive && this.layoutFx());

      this.fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.on(E.finale, 'pointermove', (e) => {
        if (!this.fine || !this.motion) return;
        const r = E.coreWrap.getBoundingClientRect();
        this.tilt.ty = (cl(((e.clientX - (r.left + r.width / 2)) / window.innerWidth) * 2 * 0.5 + 0.5) * 2 - 1) * 7;
        this.tilt.tx = -(cl(((e.clientY - (r.top + r.height / 2)) / window.innerHeight) * 2 * 0.5 + 0.5) * 2 - 1) * 5;
        this.kick();
      }, { passive: true });
      this.on(E.finale, 'pointerleave', () => {
        this.tilt.tx = 0;
        this.tilt.ty = 0;
        this.kick();
      });

      // Sichtbarkeit: Finale (Goldstaub, Gold), Siegel-Linie (Schimmer), Lichtspuren B und C
      const finIO = new IntersectionObserver((es) => {
        es.forEach((en) => {
          this.visible = en.isIntersecting;
        });
        this.pauseGold();
        this.kick();
      }, { rootMargin: '200px 0px' });
      finIO.observe(E.finale);
      const nahIO = new IntersectionObserver((es) => {
        es.forEach((en) => {
          this.nahe = en.isIntersecting;
        });
        if (this.nahe) this.kick();
      }, { rootMargin: '100% 0px' });
      nahIO.observe(E.finale);
      const botIO = new IntersectionObserver((es) => {
        es.forEach((en) => {
          this.botVisible = en.isIntersecting;
        });
        this.pauseGold();
      }, { rootMargin: '100px 0px' });
      if (E.trackC) botIO.observe(E.trackC);
      const trkIO = new IntersectionObserver((es) => {
        es.forEach((en) => {
          const k = en.target === E.trackB ? 'B' : 'C';
          this.vis[k] = en.isIntersecting;
          if (en.isIntersecting) this.tryTrack(k);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      if (E.trackB) trkIO.observe(E.trackB);
      if (E.trackC) trkIO.observe(E.trackC);
      this.ab.push(() => [finIO, nahIO, botIO, trkIO].forEach((o) => o.disconnect()));

      this.masse();
      this.startGold();
      if (this.motion) this.applyInitial();
      else this.endbild();
      this.kick();
    }

    layoutFx() {
      if (!this.alive || !this.fertig) return;
      this.buildLines();
      this.initGlitter();
      this.applyFrame(true);
      if (!this.motion || !this.glitterOn) this.drawGlitter(0);
      this.masse();
    }

    // Breiten für die Lichtspuren der Verriegelung vorab messen (sonst erzwingt lock() mitten im Bild ein Layout)
    masse() {
      const E = this.E;
      this.stageW = E.stage ? E.stage.offsetWidth : 0;
      this.l2W = E.l2 ? E.l2.offsetWidth : 0;
    }

    schmal() {
      return window.innerWidth < 768;
    }

    // Lichtspuren: senkrecht von oben, weich in die Waagrechte zum Kern
    buildLines() {
      const el = this.E.lines;
      if (!el) return;
      const W = el.offsetWidth;
      const H = el.offsetHeight;
      if (!W || !H) return;
      const cx = W / 2;
      const xs = this.schmal() ? [0.06, 0.3, 0.7, 0.94] : [0.04, 0.17, 0.32, 0.68, 0.83, 0.96];
      const gold = this.gold !== 'aus';
      let base = '';
      let glow = '';
      let spark = '';
      xs.forEach((f, i) => {
        const x = f * W;
        const dir = x < cx ? 1 : -1;
        const dist = Math.abs(cx - x);
        const k = Math.min(H * 0.55, dist * 0.7, 120 + dist * 0.35);
        const d = `M${x.toFixed(1)} 0L${x.toFixed(1)} ${(H - k).toFixed(1)}Q${x.toFixed(1)} ${H} ${(x + dir * k).toFixed(1)} ${H}L${cx} ${H}`;
        const inner = xs.length === 6 ? i === 2 || i === 3 : i === 1 || i === 2;
        const g = gold && inner ? `url(#hfsLG-${this.uid})` : `url(#hfsLM-${this.uid})`;
        base += `<path data-l="1" d="${d}" pathLength="1" stroke="${g}" stroke-width="1" stroke-dasharray="1 1" stroke-dashoffset="1"/>`;
        glow += `<path data-l="1" d="${d}" pathLength="1" stroke="${g}" stroke-width="5" opacity="0.14" stroke-dasharray="1 1" stroke-dashoffset="1"/>`;
        spark += `<path data-s="1" d="${d}" pathLength="1" stroke="#fff5fd" stroke-width="1.6" stroke-linecap="round" stroke-dasharray="0.03 2" stroke-dashoffset="0.03" opacity="0"/>`;
      });
      el.innerHTML = `<svg viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" fill="none" style="position:absolute;inset:0;overflow:visible"><defs>
        <linearGradient id="hfsLM-${this.uid}" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="${H}"><stop offset="0" stop-color="#d63ad0" stop-opacity="0"/><stop offset=".4" stop-color="#d63ad0" stop-opacity=".22"/><stop offset="1" stop-color="#ec62e8" stop-opacity=".9"/></linearGradient>
        <linearGradient id="hfsLG-${this.uid}" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="${H}"><stop offset="0" stop-color="#e9c46a" stop-opacity="0"/><stop offset=".4" stop-color="#e9c46a" stop-opacity=".2"/><stop offset="1" stop-color="#f6dc94" stop-opacity=".85"/></linearGradient>
      </defs>${glow}${base}${spark}</svg>`;
      this.linePaths = Array.from(el.querySelectorAll('[data-l]'));
      this.sparkPaths = Array.from(el.querySelectorAll('[data-s]'));
    }

    // Goldstaub: Funken auf dem Goldring, auf der Ringschrift und frei schwebend
    initGlitter() {
      const c = this.E.glitter;
      if (!c) return;
      const W = c.offsetWidth;
      if (!W) return;
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      c.width = Math.round(W * dpr);
      c.height = Math.round(W * dpr);
      this.gctx = c.getContext('2d');
      if (!this.gctx) return;
      this.gctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.gW = W;
      this.gS = W / 1.4;
      const lvl = this.gold;
      let n = lvl === 'reich' ? 110 : lvl === 'aus' ? 0 : 54;
      if (!this.partikel) n = 0;
      if (this.schmal()) n = Math.round(n * 0.6);
      this.gMul = lvl === 'reich' ? 1.35 : 1;
      const cols = ['255,214,140', '255,236,190', '232,180,92', '255,246,220'];
      const rnd = (a, b) => a + Math.random() * (b - a);
      this.parts = [];
      const nt = Math.round(n * 0.35);
      for (let i = 0; i < nt; i++) this.parts.push({ tx: true, a: rnd(0, 6.283), w: 0, r: rnd(0.426, 0.452), s: rnd(0.5, 1.1), al: rnd(0.35, 0.8), ts: rnd(0.35, 1.1), ph: rnd(0, 6.283), c: cols[i % 4] });
      for (let i = 0; i < n; i++) {
        const ch = i < n * 0.62;
        this.parts.push(
          ch
            ? { ch: true, a: rnd(0, 6.283), w: 0.1745 * rnd(0.92, 1.08), j: rnd(-0.0055, 0.0055), s: rnd(0.5, 1.25), al: rnd(0.45, 0.95), ts: rnd(0.6, 2.2), ph: rnd(0, 6.283), c: cols[i % 4] }
            : { ch: false, a: rnd(0, 6.283), w: rnd(0.012, 0.045) * (Math.random() < 0.5 ? -1 : 1), r: rnd(0.53, 0.68), ba: rnd(0.004, 0.014), bs: rnd(0.2, 0.6), s: rnd(0.4, 1.05), al: rnd(0.18, 0.55), ts: rnd(0.4, 1.4), ph: rnd(0, 6.283), c: cols[i % 4] }
        );
      }
      this.glitterOn = n > 0;
    }

    drawGlitter(ts) {
      const ctx = this.gctx;
      if (!ctx) return;
      const W = this.gW;
      const S = this.gS;
      const cx = W / 2;
      const mul = this.gMul || 1;
      ctx.clearRect(0, 0, W, W);
      if (!this.glitterOn) return;
      ctx.globalCompositeOperation = 'lighter';
      const Rch = S * 0.5 * (386 / 500);
      for (const p of this.parts) {
        const a = p.a + ts * p.w;
        const r = p.ch ? Rch + p.j * S : p.tx ? p.r * S : p.r * S + Math.sin(ts * p.bs + p.ph) * p.ba * S;
        const x = cx + Math.cos(a) * r;
        const y = cx + Math.sin(a) * r;
        const tw = 0.5 + 0.5 * Math.sin(ts * p.ts + p.ph);
        const sp = Math.pow(tw, p.tx ? 16 : 10);
        ctx.fillStyle = `rgba(${p.c},${Math.min(1, p.al * (0.25 + 0.75 * tw) * mul)})`;
        ctx.beginPath();
        ctx.arc(x, y, p.s * (0.7 + 0.5 * tw), 0, 6.283);
        ctx.fill();
        if (sp > 0.35) {
          const L = p.s * 7 * sp;
          ctx.strokeStyle = `rgba(255,244,214,${Math.min(1, sp * 0.75 * mul)})`;
          ctx.lineWidth = 0.6;
          ctx.beginPath();
          ctx.moveTo(x - L, y);
          ctx.lineTo(x + L, y);
          ctx.moveTo(x, y - L);
          ctx.lineTo(x, y + L);
          ctx.stroke();
        }
      }
    }

    // Ruhige Dauerbewegung: Goldring dreht in 36 s, Schweizer Zeile schimmert, Siegel-Linie glänzt.
    // Touch und schmal: Schimmer als einzelner Lauf alle 11 s statt dauernd (jeder Schimmer zeichnet Text neu).
    startGold() {
      [this.goldSpin, this.swissShim, this.cShimA].forEach((a) => a && a.cancel());
      this.goldSpin = this.swissShim = this.cShimA = null;
      clearTimeout(this.shimT);
      const E = this.E;
      if (!this.motion || !E.gold || !E.gold.animate) {
        this.pauseGold();
        return;
      }
      this.goldSpin = E.gold.animate([{ transform: 'translateZ(3px) rotate(0deg)' }, { transform: 'translateZ(3px) rotate(360deg)' }], { duration: 36000, iterations: Infinity });
      if (this.leicht) {
        this.schimmerPlanen(2600);
      } else {
        if (E.swiss) this.swissShim = E.swiss.animate([{ backgroundPosition: '115% 0' }, { backgroundPosition: '-15% 0' }], { duration: 8000, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
        if (E.cShim) this.cShimA = E.cShim.animate([{ backgroundPosition: '100% 0' }, { backgroundPosition: '0% 0' }], { duration: 9000, iterations: Infinity, easing: 'linear' });
      }
      this.pauseGold();
    }

    schimmerPlanen(warte) {
      clearTimeout(this.shimT);
      this.shimT = setTimeout(() => {
        if (!this.alive || !this.motion) return;
        const E = this.E;
        const an = this.gold !== 'aus' && !document.hidden;
        if (an && this.visible && E.swiss) E.swiss.animate([{ backgroundPosition: '50% 0' }, { backgroundPosition: '115% 0' }, { backgroundPosition: '-15% 0' }, { backgroundPosition: '50% 0' }], { duration: 3200, easing: 'ease-in-out' });
        if (an && this.botVisible && E.cShim) E.cShim.animate([{ backgroundPosition: '50% 0' }, { backgroundPosition: '100% 0' }, { backgroundPosition: '0% 0' }, { backgroundPosition: '50% 0' }], { duration: 3600, easing: 'linear' });
        this.schimmerPlanen(11000);
      }, warte);
    }

    pauseGold() {
      const on = this.gold !== 'aus';
      const sichtbar = this.visible && !document.hidden;
      const svg = this.E.outerDet && this.E.outerDet.querySelector('svg');
      if (svg && svg.pauseAnimations) {
        if (this.motion && sichtbar && on && !this.leicht) svg.unpauseAnimations();
        else svg.pauseAnimations();
      }
      [[this.goldSpin, sichtbar], [this.swissShim, sichtbar && on], [this.cShimA, this.botVisible && !document.hidden && on]].forEach(([a, v]) => {
        if (!a) return;
        if (v) a.play();
        else a.pause();
      });
      if (sichtbar) this.kick();
    }

    kick() {
      if (!this.raf && this.alive && this.fertig) this.raf = requestAnimationFrame(this.frame);
    }

    frame = (now) => {
      this.raf = 0;
      if (!this.alive) return;
      const dt = this.last ? Math.min(0.05, (now - this.last) / 1000) : 0.016;
      this.last = now;
      let busy = false;
      if (this.motion) busy = this.updateScroll(dt);
      // Goldstaub höchstens 30-mal pro Sekunde (Touch und schmal: rund 16-mal), nur sichtbar und im Vordergrund.
      // Bewegt sich sonst nichts, wartet die Schleife per Timer statt jedes Bild anzufordern.
      const iv = this.leicht ? 60 : 32;
      let glitzer = false;
      if (this.motion && this.glitterOn && this.visible && !document.hidden) {
        if (!this.gLast || now - this.gLast >= iv - 4) {
          this.gLast = now;
          this.drawGlitter(now / 1000);
        }
        glitzer = true;
      }
      if (busy) {
        this.kick();
      } else {
        this.last = 0;
        if (glitzer) {
          clearTimeout(this.gT);
          this.gT = setTimeout(() => this.kick(), Math.max(0, iv - (performance.now() - this.gLast)));
        }
      }
    };

    targetT() {
      const r = this.E.coreWrap.getBoundingClientRect();
      const vh = window.innerHeight;
      const cy = r.top + r.height / 2;
      return cl((vh * 1.2 - cy) / (vh * 0.8));
    }

    updateScroll(dt) {
      if (this.locked && Math.abs(this.tilt.tx - this.tilt.x) < 0.001 && Math.abs(this.tilt.ty - this.tilt.y) < 0.001) return false;
      const tgt = this.locked ? 1 : this.targetT();
      const k = 1 - Math.exp(-dt * 6.5);
      const prevT = this.sT;
      this.sT += (tgt - this.sT) * k;
      if (Math.abs(tgt - this.sT) < 0.0004) this.sT = tgt;
      const tx0 = this.tilt.x;
      const ty0 = this.tilt.y;
      const kt = 1 - Math.exp(-dt * 5);
      this.tilt.x += (this.tilt.tx - this.tilt.x) * kt;
      this.tilt.y += (this.tilt.ty - this.tilt.y) * kt;
      const moving = Math.abs(this.sT - prevT) > 0.00005 || Math.abs(this.tilt.x - tx0) > 0.001 || Math.abs(this.tilt.y - ty0) > 0.001 || Math.abs(tgt - this.sT) > 0;
      if (moving || !this.drawnOnce) {
        this.applyFrame();
        this.drawnOnce = true;
      }
      if (!this.locked && this.sT > 0.985) this.lock();
      return moving;
    }

    applyFrame() {
      const E = this.E;
      if (!E.core) return;
      const T = this.locked || !this.motion ? 1 : this.sT;
      const dl = eo(cl(T / 0.62));
      (this.linePaths || []).forEach((p) => {
        p.style.strokeDashoffset = String(1 - dl);
      });
      (this.sparkPaths || []).forEach((p) => {
        p.style.strokeDashoffset = String(0.03 - dl);
        p.style.opacity = !this.locked && dl > 0.01 && dl < 0.995 ? '0.95' : '0';
      });
      const rev = eo(cl((T - 0.1) / 0.5));
      if (E.shade) E.shade.style.opacity = String(1 - rev);
      const tiltBase = this.motion ? 20 * (1 - eo(cl((T - 0.08) / 0.8))) : 0;
      const a = eio(cl((T - 0.3) / 0.58));
      const b = eo(cl((T - 0.84) / 0.12));
      const tx = this.motion ? this.tilt.x : 0;
      const ty = this.motion ? this.tilt.y : 0;
      E.core.style.transform = `rotateX(${(tiltBase + tx).toFixed(3)}deg) rotateY(${ty.toFixed(3)}deg) scale(${(0.86 + 0.14 * rev).toFixed(4)})`;
      if (E.outerDet) E.outerDet.style.transform = `translateZ(5px) rotate(${(-36 * (1 - a)).toFixed(3)}deg)`;
      if (E.innerDet) E.innerDet.style.transform = `translateZ(11px) rotate(${(56 * (1 - a)).toFixed(3)}deg)`;
      if (E.bolts) E.bolts.style.setProperty('--bo', (1 - b).toFixed(4));
      if (E.spec) E.spec.style.backgroundPosition = `${((1 - rev) * 90 + 50 - ty * 3).toFixed(2)}% ${(50 + tx * 3).toFixed(2)}%`;
      if (E.haze) E.haze.style.opacity = String(0.25 + 0.75 * rev);
      if (E.floor) E.floor.style.opacity = String(rev);
    }

    anim(el, kf, o) {
      if (!el || !el.animate) return null;
      const a = el.animate(kf, Object.assign({ fill: 'both' }, o));
      this.anims.push(a);
      return a;
    }

    later(fn, ms) {
      this.timers.push(setTimeout(() => this.alive && fn(), ms));
    }

    clearSeq() {
      (this.anims || []).forEach((a) => a.cancel());
      this.anims = [];
      (this.timers || []).forEach(clearTimeout);
      this.timers = [];
    }

    // Verriegelung: einmalige Folge wie im Prototyp
    lock() {
      if (this.locked) return;
      this.locked = true;
      if (!this.motion) {
        this.endbild();
        return;
      }
      const E = this.E;
      const ease = 'cubic-bezier(.16,.84,.24,1)';
      this.applyFrame();
      this.anim(E.outerDet, [{ transform: 'translateZ(5px) rotate(-0.9deg)' }, { transform: 'translateZ(5px) rotate(0.25deg)', offset: 0.6 }, { transform: 'translateZ(5px) rotate(0deg)' }], { duration: 520, easing: ease, fill: 'none' });
      this.anim(E.innerLit, [{ opacity: 0 }, { opacity: 1 }], { duration: 500, delay: 40 });
      this.anim(E.outerLit, [{ opacity: 0 }, { opacity: 1 }], { duration: 500, delay: 90 });
      this.anim(E.glow, [{ opacity: 0.16 }, { opacity: 1, offset: 0.35 }, { opacity: 0.72 }], { duration: 1600, delay: 120 });
      this.anim(E.pulse, [{ opacity: 0, transform: 'translateZ(12px) scale(0.97)' }, { opacity: 0.85, transform: 'translateZ(12px) scale(1)', offset: 0.08 }, { opacity: 0, transform: 'translateZ(12px) scale(1.6)' }], { duration: 1700, delay: 130, easing: 'cubic-bezier(.2,.6,.2,1)' });
      const hw = (this.stageW || E.stage.offsetWidth) / 2 + 240;
      this.anim(E.hzR, [{ opacity: 0, transform: 'translateX(0px)' }, { opacity: 1, offset: 0.12 }, { opacity: 0, transform: `translateX(${hw}px)` }], { duration: 1600, delay: 200, easing: 'cubic-bezier(.3,.6,.3,1)' });
      this.anim(E.hzL, [{ opacity: 0, transform: 'translateX(0px)' }, { opacity: 1, offset: 0.12 }, { opacity: 0, transform: `translateX(${-hw}px)` }], { duration: 1600, delay: 200, easing: 'cubic-bezier(.3,.6,.3,1)' });
      this.anim(E.lines, [{ opacity: 1 }, { opacity: 0.42 }], { duration: 1800, delay: 250 });
      this.anim(E.l1, [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0px)' }], { duration: 900, delay: 380, easing: ease });
      const w2 = this.l2W || (E.l2 ? E.l2.offsetWidth : 0);
      this.anim(E.l2, [{ clipPath: 'inset(-20% 100% -20% 0)' }, { clipPath: 'inset(-20% 0% -20% 0)' }], { duration: 1250, delay: 800, easing: 'cubic-bezier(.65,0,.35,1)' });
      this.anim(E.l2bar, [{ opacity: 0, transform: 'translateX(0px)' }, { opacity: 1, offset: 0.08 }, { opacity: 1, offset: 0.9 }, { opacity: 0, transform: `translateX(${w2}px)` }], { duration: 1250, delay: 800, easing: 'cubic-bezier(.65,0,.35,1)' });
      this.anim(E.swiss, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0px)' }], { duration: 900, delay: 1700, easing: ease });
      this.anim(E.sent, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0px)' }], { duration: 900, delay: 1950, easing: ease });
      this.later(() => this.playA(), 2150);
    }

    playA() {
      if (this.played.A) return;
      this.played.A = true;
      this.anim(this.E.taT, [{ opacity: 0, transform: 'translateY(-100%)' }, { opacity: 1, offset: 0.2 }, { opacity: 0, transform: 'translateY(200%)' }], { duration: 800, easing: 'cubic-bezier(.4,0,.6,1)' });
      this.later(() => {
        this.tryTrack('B');
        this.tryTrack('C');
      }, 650);
    }

    tryTrack(k) {
      if (!this.motion || !this.locked || this.played[k] || !this.vis[k] || !this.played.A) return;
      this.played[k] = true;
      const E = this.E;
      const run = (L, R, trk, dur) => {
        if (!trk) return;
        const w = trk.offsetWidth / 2 + 220;
        this.anim(R, [{ opacity: 0, transform: 'translateX(0px)' }, { opacity: 1, offset: 0.1 }, { opacity: 0, transform: `translateX(${w}px)` }], { duration: dur, easing: 'cubic-bezier(.35,.1,.3,1)' });
        this.anim(L, [{ opacity: 0, transform: 'translateX(0px)' }, { opacity: 1, offset: 0.1 }, { opacity: 0, transform: `translateX(${-w}px)` }], { duration: dur, easing: 'cubic-bezier(.35,.1,.3,1)' });
      };
      if (k === 'B') run(E.tbL, E.tbR, E.trackB, 1500);
      if (k === 'C') {
        this.anim(E.seal, [{ boxShadow: 'inset 0 0 0 1px rgba(233,196,106,0.85), 0 0 10px rgba(233,196,106,0.3)' }, { boxShadow: 'inset 0 0 0 1px rgba(255,236,190,1), 0 0 22px rgba(233,196,106,0.75)', offset: 0.3 }, { boxShadow: 'inset 0 0 0 1px rgba(233,196,106,0.85), 0 0 10px rgba(233,196,106,0.3)' }], { duration: 1400 });
        run(E.tcL, E.tcR, E.trackC, 1700);
        this.anim(E.cFill, [{ opacity: 0 }, { opacity: 1 }], { duration: 1400, delay: 500 });
        [E.gL, E.gR].forEach((g) => this.anim(g, [{ opacity: 0, transform: 'scale(0.2)' }, { opacity: 1, transform: 'scale(1.5)', offset: 0.4 }, { opacity: 0.55, transform: 'scale(1)' }], { duration: 1100, delay: 1250, easing: 'cubic-bezier(.2,.7,.2,1)' }));
      }
    }

    // Ausgangslage vor dem Scrollen (nur mit Bewegung)
    applyInitial() {
      const E = this.E;
      this.locked = false;
      this.played = {};
      this.drawnOnce = false;
      if (E.outerLit) E.outerLit.style.opacity = '0';
      if (E.innerLit) E.innerLit.style.opacity = '0';
      if (E.lines) E.lines.style.opacity = '1';
      this.applyFrame();
    }

    // Endbild: alles sichtbar, Ringe ausgerichtet, keine Folge mehr
    endbild() {
      const E = this.E;
      this.clearSeq();
      this.locked = true;
      this.played = { A: true, B: true, C: true };
      this.classList.remove('is-armed');
      this.querySelectorAll('[data-hfs-reveal]').forEach((el) => {
        el.classList.add('is-in');
        if (this.revIO) this.revIO.unobserve(el);
      });
      if (E.outerLit) E.outerLit.style.opacity = '1';
      if (E.innerLit) E.innerLit.style.opacity = '1';
      if (E.lines) E.lines.style.opacity = '0.42';
      if (this.fertig) {
        this.applyFrame();
        this.drawGlitter(0);
        this.startGold();
      }
    }
  }

  customElements.define('hodl-final-seal', HodlFinalSeal);
})();
